import { NavLink } from "react-router-dom";
import { useState } from "react";
import {
  FaUsers,
  FaLink,
  FaChartBar,
  FaCreditCard,
  FaQrcode,
  FaCog,
  FaBlog,
  FaChevronDown,
  FaChevronRight
} from "react-icons/fa";

export default function AdminSidebar() {

  const [blogOpen, setBlogOpen] = useState(false);

  return (
    <div
      className="bg-dark text-white p-3"
      style={{ width: "260px", minHeight: "100vh" }}
    >

      <h4 className="fw-bold mb-4">Admin Panel</h4>

      <ul className="nav nav-pills flex-column gap-2">

        {/* DASHBOARD */}

        <li className="nav-item">
          <NavLink className="nav-link text-white" to="/admin/dashboard">
            <FaChartBar className="me-2" />
            Dashboard
          </NavLink>
        </li>

        {/* USERS */}

        <li className="nav-item">
          <NavLink className="nav-link text-white" to="/admin/users">
            <FaUsers className="me-2" />
            Users
          </NavLink>
        </li>

        {/* LINKS */}

        <li className="nav-item">
          <NavLink className="nav-link text-white" to="/admin/links">
            <FaLink className="me-2" />
            Links
          </NavLink>
        </li>

        {/* BLOG DROPDOWN */}

        <li className="nav-item">

          <button
            className="nav-link text-white d-flex justify-content-between align-items-center w-100"
            onClick={() => setBlogOpen(!blogOpen)}
            style={{ background: "transparent", border: "none" }}
          >
            <span>
              <FaBlog className="me-2" />
              Blogs
            </span>

            {blogOpen ? <FaChevronDown /> : <FaChevronRight />}
          </button>

          {blogOpen && (
            <ul className="nav flex-column ms-4 mt-2">

              <li className="nav-item">
                <NavLink
                  className="nav-link text-white"
                  to="/admin/blog/create"
                >
                  Create Blog
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className="nav-link text-white"
                  to="/admin/blogs"
                >
                  Manage Blogs
                </NavLink>
              </li>

            </ul>
          )}

        </li>

        {/* SUBSCRIPTIONS */}

        <li className="nav-item">
          <NavLink className="nav-link text-white" to="/admin/subscriptions">
            <FaCreditCard className="me-2" />
            Subscriptions
          </NavLink>
        </li>

        {/* QR CODES */}

        <li className="nav-item">
          <NavLink className="nav-link text-white" to="/admin/qrcodes">
            <FaQrcode className="me-2" />
            QR Codes
          </NavLink>
        </li>

        {/* SETTINGS */}

        <li className="nav-item mt-3">
          <NavLink className="nav-link text-white" to="/admin/settings">
            <FaCog className="me-2" />
            Settings
          </NavLink>
        </li>

      </ul>

    </div>
  );
}